export const FEATURE = {
    ENABLE_AMS_USER_ORCHESTRATION : 'EnableAMSUserOrchestration',
    USE_DECOUPLED_DATA_SERVICE : 'UseDecoupledDataService'
};
